
<div v-if="!renderData.loading">
  <component :is="renderData.currentThemeIndex">
    <template #uploadContainer>
      <slot name="uploadContainer"></slot>
    </template>

    <template #listContainer>
      <slot name="listContainer"></slot>
    </template>
  </component>
</div>
